import Component from './component';

export default class Section extends Component {}
